module.exports = __webpack_public_path__ + "img/2015011.da5600be.svg";